import React, { useState, useEffect } from "react";
import axios from "axios";
import { MyUrl } from "../../../App";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import Lottie from "lottie-react";
import reloadpage from "../../../reloadpage.json";

import { Divider } from "antd";
import Calendar from "../../../Images/Calendar.png";
import SupplyReportsTop3 from "./SupplyReportsTop3";
import SupplyReportsFirstGraph from "./SupplyReportsFirstGraph";
import SupplyReportsSourceOptimizationReportTable from "./SupplyReportsSourceOptimizationReportTable";
import SupplyReports3Donuts from "./SupplyReports3Donuts";
import SupplyReportsOpportunityRadar from "./SupplyReportsOpportunityRadar";
import SupplyReports2Tables from "./SupplyReports2Tables";
import SupplyReports2Tables2 from "./SupplyReports2Tables2";
import jwt_decode from "jwt-decode";
var jwtToken = "";

var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};

var SendDataToIncomeGraph = [];
var ObjSendDataToIncomeGraph = {};

var SendDataToSecondTable = [];
var ObjSendDataToSecondTable = {};

var SendDataToTop3 = [];
var ObjSendDataToTop3 = {};

var SendDataToGraphData = [];
var ObjSendDataToGraphData = {};
var SendDataToGraphData1 = [];
var ObjSendDataToGraphData1 = {};
var SendDataToGraphData2 = [];
var ObjSendDataToGraphData2 = {};
var SendDataToGraphData3 = [];
var ObjSendDataToGraphData3 = {};

var SendDataToCampOptimization = [];
var ObjSendDataToCampOptimization = {};

var SendDataTo3Donut = [];
var ObjSendDataTo3Donut = {};

var SendDataTo3Donut1 = [];
var ObjSendDataTo3Donut1 = {};

var SendDataTo3Donut2 = [];
var ObjSendDataTo3Donut2 = {};

var SendDataToOpportunity = [];
var ObjSendDataToOpportunity = {};

var SendDataToTopFillingApps = [];
var ObjSendDataToTopFillingApps = {};

var SendDataToAppQuality = [];
var ObjSendDataToAppQuality = {};
var PickedDate = 0;
const styles = {
  root: {
    "&$checked": {
      color: "#3f51b5",
    },
  },
  checked: {},
  circle: {
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: "#fff",
    border: "2px solid #fff", // we can add color after solid
  },
  checkedIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: "white",
  },
};

const CircleCheckbox = withStyles(styles)(({ classes, ...props }) => (
  <Checkbox
    {...props}
    classes={{
      root: classes.root,
      checked: classes.checked,
    }}
    icon={<span className={classes.circle} />}
    checkedIcon={
      <span className={classes.checkedIcon}>
        <CheckIcon style={{ fontSize: 16, color: "black" }} />
      </span>
    }
  />
));

export default function SupplyReportsGetDataAndFilter() {
  const [CheckTypeOfUser, setCheckTypeOfUser] = React.useState("");
  const [isClicked, setIsClicked] = useState(false);

  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  //const MyToken = JSON.parse(localStorage.getItem("Token"));
  const MyToken = JSON.parse(sessionStorage.getItem("Token"));

  const base64Url = MyToken.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const payload = JSON.parse(atob(base64));
  const expirationDate = new Date(payload.exp * 1000);
  const currentTime = new Date().getTime(); // Get the current time in milliseconds
  // useEffect(() => {
  //   function handleFocus() {
  //     console.log("Component is focused");
  //   }
  //   function handleBlur() {
  //     console.log("Component is unfocused");
  //   }
  //   window.addEventListener("focus", handleFocus);
  //   window.addEventListener("blur", handleBlur);
  //   const items = sessionStorage.getItem("Token");
  //   var parsed = JSON.parse(items);
  //   const token = sessionStorage.getItem("Token");
  //   const decodedToken = jwt_decode(token);
  //   const role =
  //     decodedToken[
  //       "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  //     ];
  //   setCheckTypeOfUser(role);
  //   jwtToken = parsed;
  //   const base64Url = jwtToken.split(".")[1];
  //   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //   const payload = JSON.parse(atob(base64));
  //   const expirationDate = new Date(payload.exp * 1000);
  //   const currentTime = new Date().getTime(); // Get the current time in milliseconds
  //   if (expirationDate < currentTime) {
  //     try {
  //       axios
  //         .post(
  //           `${MyUrl}/api/RefreshToken/refresh`,
  //           { accessToken: jwtToken.replace("Bearer ", "") },
  //           { withCredentials: true }
  //         )
  //         .then((response) => {
  //           parsed = response.data.accessToken;
  //           const updatedObjString = JSON.stringify(response.data.accessToken);
  //           sessionStorage.setItem("Token", updatedObjString);
  //           GetSupplyAppQualityDataFunc();
  //           GetSupplyTopFillingAppsFunc();
  //           GetSupplyOpportunityDataFunc();
  //           GetSupplyTrafficSourceDonut();
  //           GetSupply3DonutDataFunc();
  //           GetSupplyReportsCampOptimizationDataFunc();
  //           GetSupplyReportsGraphDataFunc();
  //           GetSupplyReportsDataFunc();
  //           setChooceCompanies([]);
  //           PickDatesToGetData(0);
  //           GetDailyIncomeFunc();
  //           //GetDailyIncomeFunc1();
  //           GetMonthlyIncomeFunc();
  //           return () => {
  //             source.cancel("Component unmounted");
  //           };
  //           return () => {
  //             source.cancel("Component unmounted");
  //           };
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     const items = sessionStorage.getItem("Token");
  //     var parsed = JSON.parse(items);
  //     jwtToken = parsed;
  //     GetSupplyAppQualityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsDataFunc();
  //     setChooceCompanies([]);
  //     PickDatesToGetData(0);
  //     GetDailyIncomeFunc();
  //     //GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     return () => {
  //       source.cancel("Component unmounted");
  //     };
  //     return () => {
  //       source.cancel("Component unmounted");
  //     };
  //   }
  //   return () => {
  //     window.removeEventListener("focus", handleFocus);
  //     window.removeEventListener("blur", handleBlur);
  //   };
  // }, []);
  // const RefreshFunc1 = async () => {
  //   function handleFocus() {
  //     console.log("Component is focused");
  //   }
  //   function handleBlur() {
  //     console.log("Component is unfocused");
  //   }
  //   window.addEventListener("focus", handleFocus);
  //   window.addEventListener("blur", handleBlur);
  //   const items = sessionStorage.getItem("Token");
  //   var parsed = JSON.parse(items);
  //   const token = sessionStorage.getItem("Token");
  //   const decodedToken = jwt_decode(token);
  //   const role =
  //     decodedToken[
  //       "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  //     ];
  //   setCheckTypeOfUser(role);
  //   jwtToken = parsed;
  //   const base64Url = jwtToken.split(".")[1];
  //   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //   const payload = JSON.parse(atob(base64));
  //   const expirationDate = new Date(payload.exp * 1000);
  //   const currentTime = new Date().getTime(); // Get the current time in milliseconds
  //   if (expirationDate < currentTime) {
  //     try {
  //       axios
  //         .post(
  //           `${MyUrl}/api/RefreshToken/refresh`,
  //           { accessToken: jwtToken.replace("Bearer ", "") },
  //           { withCredentials: true }
  //         )
  //         .then((response) => {
  //           parsed = response.data.accessToken;
  //           const updatedObjString = JSON.stringify(response.data.accessToken);
  //           sessionStorage.setItem("Token", updatedObjString);
  //           GetDailyIncomeFunc();
  //           return () => {
  //             source.cancel("Component unmounted");
  //           };
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     const items = sessionStorage.getItem("Token");
  //     var parsed = JSON.parse(items);
  //     jwtToken = parsed;
  //     GetDailyIncomeFunc();
  //     return () => {
  //       source.cancel("Component unmounted");
  //     };
  //   }
  //   return () => {
  //     window.removeEventListener("focus", handleFocus);
  //     window.removeEventListener("blur", handleBlur);
  //   };
  // };
  // const RefreshFunc = async () => {
  //   function handleFocus() {
  //     console.log("Component is focused");
  //   }
  //   function handleBlur() {
  //     console.log("Component is unfocused");
  //   }
  //   window.addEventListener("focus", handleFocus);
  //   window.addEventListener("blur", handleBlur);
  //   const items = sessionStorage.getItem("Token");
  //   var parsed = JSON.parse(items);
  //   const token = sessionStorage.getItem("Token");
  //   const decodedToken = jwt_decode(token);
  //   const role =
  //     decodedToken[
  //       "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  //     ];
  //   setCheckTypeOfUser(role);
  //   jwtToken = parsed;
  //   const base64Url = jwtToken.split(".")[1];
  //   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //   const payload = JSON.parse(atob(base64));
  //   const expirationDate = new Date(payload.exp * 1000);
  //   const currentTime = new Date().getTime(); // Get the current time in milliseconds
  //   if (expirationDate < currentTime) {
  //     try {
  //       axios
  //         .post(
  //           `${MyUrl}/api/RefreshToken/refresh`,
  //           { accessToken: jwtToken.replace("Bearer ", "") },
  //           { withCredentials: true }
  //         )
  //         .then((response) => {
  //           parsed = response.data.accessToken;
  //           const updatedObjString = JSON.stringify(response.data.accessToken);
  //           sessionStorage.setItem("Token", updatedObjString);
  //           GetSupplyAppQualityDataFunc();
  //           GetSupplyTopFillingAppsFunc();
  //           GetSupplyOpportunityDataFunc();
  //           GetSupplyTrafficSourceDonut();
  //           GetSupply3DonutDataFunc();
  //           GetSupplyReportsCampOptimizationDataFunc();
  //           GetSupplyReportsGraphDataFunc();
  //           GetSupplyReportsDataFunc();
  //           //setChooceCompanies([]);
  //           //PickDatesToGetData(0);
  //           GetDailyIncomeFunc1();
  //           GetMonthlyIncomeFunc();
  //           return () => {
  //             source.cancel("Component unmounted");
  //           };
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     const items = sessionStorage.getItem("Token");
  //     var parsed = JSON.parse(items);
  //     jwtToken = parsed;
  //     GetSupplyAppQualityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsDataFunc();
  //     // setChooceCompanies([]);
  //     // PickDatesToGetData(0);
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     return () => {
  //       source.cancel("Component unmounted");
  //     };
  //   }
  //   return () => {
  //     window.removeEventListener("focus", handleFocus);
  //     window.removeEventListener("blur", handleBlur);
  //   };
  // };
  // useEffect(() => {
  //   RefreshFunc();
  //   RefreshFunc1();
  // }, []);

  const RefreshFunc1 = async () => {
    const token = sessionStorage.getItem("Token");
    var parsed = JSON.parse(token);
    const decodedToken = jwt_decode(token);
    const role =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
    setCheckTypeOfUser(role);
    jwtToken = JSON.parse(token); //parsed;
    const base64Url = jwtToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    const expirationDate = new Date(payload.exp * 1000);
    const currentTime = new Date().getTime(); // Get the current time in milliseconds
    if (expirationDate < currentTime) {
      try {
        axios
          .post(
            `${MyUrl}/api/RefreshToken/refresh`,
            { accessToken: JSON.parse(token).replace("Bearer ", "") },
            { withCredentials: true }
          )
          .then((response) => {
            parsed = response.data.accessToken;
            const updatedObjString = JSON.stringify(response.data.accessToken);
            sessionStorage.setItem("Token", updatedObjString);
            GetDailyIncomeFunc();
            GetSupplyAppQualityDataFunc(startDate, endDate);
            GetSupplyTopFillingAppsFunc(startDate, endDate);
            GetSupplyOpportunityDataFunc(startDate, endDate);
            GetSupplyTrafficSourceDonut(startDate, endDate);
            GetSupply3DonutDataFunc(startDate, endDate);
            GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
            GetSupplyReportsGraphDataFunc(startDate, endDate);
            GetSupplyReportsDataFunc(startDate, endDate);
            GetDailyIncomeFunc1(startDate, endDate);
            //GetMonthlyIncomeFunc(startDate, endDate);
            //RefreshFunc(Today, Today);

            return () => {
              source.cancel("Component unmounted");
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      const items = sessionStorage.getItem("Token");
      var parsed = JSON.parse(items);
      jwtToken = JSON.parse(token); //parsed;
      GetDailyIncomeFunc();
      GetSupplyAppQualityDataFunc(startDate, endDate);
      GetSupplyTopFillingAppsFunc(startDate, endDate);
      GetSupplyOpportunityDataFunc(startDate, endDate);
      GetSupplyTrafficSourceDonut(startDate, endDate);
      GetSupply3DonutDataFunc(startDate, endDate);
      GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
      GetSupplyReportsGraphDataFunc(startDate, endDate);
      GetSupplyReportsDataFunc(startDate, endDate);
      GetDailyIncomeFunc1(startDate, endDate);
      //GetMonthlyIncomeFunc(startDate, endDate);
      //RefreshFunc(Today, Today);

      return () => {
        source.cancel("Component unmounted");
      };
    }
  };
  const RefreshFunc = async (startDate, endDate) => {
    const token = sessionStorage.getItem("Token");
    var parsed = JSON.parse(token);

    const decodedToken = jwt_decode(token);
    const role =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
    setCheckTypeOfUser(role);
    jwtToken = JSON.parse(token); //parsed;
    const base64Url = JSON.parse(token).split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    const expirationDate = new Date(payload.exp * 1000);
    const currentTime = new Date().getTime(); // Get the current time in milliseconds
    if (expirationDate < currentTime) {
      try {
        axios
          .post(
            `${MyUrl}/api/RefreshToken/refresh`,
            { accessToken: JSON.parse(token).replace("Bearer ", "") },
            { withCredentials: true }
          )
          .then((response) => {
            parsed = response.data.accessToken;
            const updatedObjString = JSON.stringify(response.data.accessToken);
            sessionStorage.setItem(
              "Token",
              JSON.stringify(response.data.accessToken)
            );

            GetSupplyAppQualityDataFunc(startDate, endDate);
            GetSupplyTopFillingAppsFunc(startDate, endDate);
            GetSupplyOpportunityDataFunc(startDate, endDate);
            GetSupplyTrafficSourceDonut(startDate, endDate);
            GetSupply3DonutDataFunc(startDate, endDate);
            GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
            GetSupplyReportsGraphDataFunc(startDate, endDate);
            GetSupplyReportsDataFunc(startDate, endDate);
            GetDailyIncomeFunc1(startDate, endDate);
            //GetMonthlyIncomeFunc(startDate, endDate);
            return () => {
              source.cancel("Component unmounted");
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      const items = sessionStorage.getItem("Token");
      var parsed = JSON.parse(items);
      jwtToken = JSON.parse(items); //parsed;
      GetSupplyAppQualityDataFunc(startDate, endDate);
      GetSupplyTopFillingAppsFunc(startDate, endDate);
      GetSupplyOpportunityDataFunc(startDate, endDate);
      GetSupplyTrafficSourceDonut(startDate, endDate);
      GetSupply3DonutDataFunc(startDate, endDate);
      GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
      GetSupplyReportsGraphDataFunc(startDate, endDate);
      GetSupplyReportsDataFunc(startDate, endDate);
      GetDailyIncomeFunc1(startDate, endDate);
      //GetMonthlyIncomeFunc(startDate, endDate);

      return () => {
        source.cancel("Component unmounted");
      };
    }
  };

  useEffect(() => {
    setChooceCompanies([]);
    RefreshFunc1();
    // RefreshFunc(Today, Today);
  }, []);

  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState("");
  const [isLoading1, setIsLoading1] = useState(true);
  const [data1, setData1] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);
  const [data2, setData2] = useState("");

  const [isLoading3, setIsLoading3] = useState(true);
  const [data3, setData3] = useState("");

  const [isLoading4, setIsLoading4] = useState(true);
  const [data4, setData4] = useState("");

  const [isLoading5, setIsLoading5] = useState(true);
  const [data5, setData5] = useState("");

  const [isLoading6, setIsLoading6] = useState(true);
  const [data6, setData6] = useState("");

  const [isLoading7, setIsLoading7] = useState(true);
  const [data7, setData7] = useState("");

  const [isLoading8, setIsLoading8] = useState(true);
  const [data8, setData8] = useState("");

  const [isLoading9, setIsLoading9] = useState(true);
  const [data9, setData9] = useState("");

  const [isLoading10, setIsLoading10] = useState(true);
  const [data10, setData10] = useState("");

  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");
  //when pick yesterday
  const Yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  //when pick 7 days
  const SevenDays = moment().subtract(7, "day").format("YYYY-MM-DD");

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  const currentDate = moment();
  const daysInCurrentMonth = currentDate.daysInMonth();

  const handleCheckboxChange = (event, productName) => {
    if (event.target.checked) {
      setChooceCompanies([...chooceCompanies, productName]); // add to array
    } else {
      setChooceCompanies(
        chooceCompanies.filter((name) => name !== productName)
      ); // remove from array
    }
  };

  const products = ["Product A", "Product B", "Product C"];
  // console.log(chooceCompanies);

  const idsArray = [1, 2, 3, 4];

  const IdsToGetData = chooceCompanies
    .map((id) => "&ids=" + String(id))
    .join("");

  //  console.log(IdsToGetData); // "&ids=1&ids=2&ids=3&ids=4"
  // const GetDailyIncomeFunc = () => {
  //   const items = sessionStorage.getItem("Token");
  //   console.log(items);
  //   var parsed = JSON.parse(items);
  //   console.log(parsed);

  //   console.log("GetDailyIncomeFunc");
  //   setIsLoading(true);
  //   try {
  //     let base64 = require("base-64"); // install it before use from npm i base-64
  //     axios
  //       .get(
  //         `${MyUrl}/api/Dashboard/getDailyIncome?&startDate=${startDate}&endDate=${endDate}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
  //           },
  //           cancelToken: source.token,
  //         }
  //       )
  //       .then((res) => {
  //         const data = res.data;
  //         setData(data);
  //         //       console.log(data);
  //         for (let i = 0; i < data.responseData.length; i++) {
  //           console.log(data.responseData[i].id);

  //           setChooceCompanies((prevCompanies) => [
  //             ...prevCompanies,
  //             data.responseData[i].id,
  //           ]);
  //         }
  //       })
  //       .catch((error) => {})
  //       .finally(() => {
  //         setIsLoading(false);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const GetDailyIncomeFunc = () => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    setIsLoading(true);
    try {
      let base64 = require("base-64"); // install it before use from npm i base-64
      axios
        .get(`${MyUrl}/api/Account/userSeats`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(items).replace("Bearer ", "")}`,
          },
          cancelToken: source.token,
        })
        .then((res) => {
          const data = res.data;
          setData(data);
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const GetSupplyReportsDataFunc = (a) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    SendDataToTop3 = [];
    setIsLoading3(true);
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/getSupplyTeamData?${IdsToGetData}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data3 = res.data;
          console.log(data3);
          setData3(data3);
          SendDataToTop3.push(data3.responseData);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading3(false);
        });
    } catch (error) {}
  };

  const GetSupplyReportsGraphDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading4(true);

    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/monthlySupplyTeamData?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data4 = res.data;
          setData4(data4);
          SendDataToGraphData = [];
          SendDataToGraphData1 = [];
          SendDataToGraphData2 = [];
          SendDataToGraphData3 = [];
          for (let i = 0; i < data4.responseData.data.length; i++) {
            SendDataToGraphData.push(
              data4.responseData.data[i].averageFillRate.toFixed(4)
            );
            SendDataToGraphData1.push(
              data4.responseData.data[i].ad_requests.toFixed(2)
            );
            SendDataToGraphData2.push(
              data4.responseData.data[i].impressions_good.toFixed(2)
            );
            SendDataToGraphData3.push(data4.responseData.data[i].date.name); //data4.responseData.data[i].date.name
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading4(false);
        });
    } catch (error) {}
  };

  const GetSupplyReportsCampOptimizationDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    setIsLoading5(true);
    SendDataToCampOptimization = [];
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/sourceOptimization?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data5 = res.data;
          setData5(data5);
          SendDataToCampOptimization = [];
          for (let i = 0; i < data5.responseData.data.length; i++) {
            ObjSendDataToCampOptimization = {
              //  Id: data5.responseData.data[i].campaign.id,
              source: data5.responseData.data[i].source.name,
              SEAT: data5.responseData.data[i].seatName,
              ENV: data5.responseData.data[i].environment.name,
              Req: data5.responseData.data[i].ad_requests,
              Imp: data5.responseData.data[i].impressions_good,
              Fill: data5.responseData.data[i].fill,
              Revenue: data5.responseData.data[i].revenue_total,
              QS: Number.parseFloat(
                data5.responseData.data[i].qs.toString().replace("e-", "")
              ).toFixed(2),
            };
            SendDataToCampOptimization.push(ObjSendDataToCampOptimization);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading5(false);
        });
    } catch (error) {}
  };

  const GetSupply3DonutDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading6(true);

    //  SendDataTo3Donut2 = [];
    //  ObjSendDataTo3Donut2 = {};

    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/getImpressionData?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data6 = res.data;
          setData6(data6);
          SendDataTo3Donut = [];
          ObjSendDataTo3Donut = {};

          SendDataTo3Donut1 = [];
          ObjSendDataTo3Donut1 = {};

          for (let i = 0; i < data6.responseData.envResponse.data.length; i++) {
            ObjSendDataTo3Donut = {
              type: data6.responseData.envResponse.data[i].envName,
              value: data6.responseData.envResponse.data[i].impressions,
            };
            SendDataTo3Donut.push(ObjSendDataTo3Donut);
          }
          for (let i = 0; i < data6.responseData.osResponse.data.length; i++) {
            ObjSendDataTo3Donut1 = {
              type: data6.responseData.osResponse.data[i].osName,
              value: data6.responseData.osResponse.data[i].impressions,
            };
            SendDataTo3Donut1.push(ObjSendDataTo3Donut1);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading6(false);
        });
    } catch (error) {}
  };

  const GetSupplyTrafficSourceDonut = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    setIsLoading7(true);
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/getTrafficSource?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data = res.data;
          SendDataTo3Donut2 = [];
          console.log(data);
          for (let i = 0; i < data.responseData.length; i++) {
            ObjSendDataTo3Donut2 = {
              type: data.responseData[i].trafficSourceType,
              value: data.responseData[i].impressions,
            };
            SendDataTo3Donut2.push(ObjSendDataTo3Donut2);
          }
          console.log(SendDataTo3Donut2);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading7(false);
        });
    } catch (error) {}
  };

  const GetSupplyOpportunityDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    setIsLoading8(true);
    try {
      axios
        .get(
          //${a}${MyDateFrom}${MyDateTo}

          `${MyUrl}/api/MediaSource/getOpportunityData?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
                `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data8 = res.data;
          setData8(data8);
          SendDataToOpportunity = [];
          ObjSendDataToOpportunity = {};
          for (let i = 0; i < data8.responseData.data.length; i++) {
            // if (
            //   data8.responseData.data[i].impressions_good > 500 &&
            //   data8.responseData.data[i].fill > 0.05 &&
            //   data8.responseData.data[i].qs > 2
            // ) {
            ObjSendDataToOpportunity = {
              BillingName: data8.responseData.data[i].advertiser.billingName,
              SEAT: data8.responseData.data[i].seatName,
              source: data8.responseData.data[i].source.name,
              ENV: data8.responseData.data[i].environment.name,
              OS: data8.responseData.data[i].os.name,
              Bundle: data8.responseData.data[i].app_bundle.name,
              Region: data8.responseData.data[i].region.name,
              Req: data8.responseData.data[i].ad_requests,
              Imp: data8.responseData.data[i].impressions_good,
              Fill: data8.responseData.data[i].fill,
              Revenue: data8.responseData.data[i].revenue_total,
              QS: Number.parseFloat(
                data8.responseData.data[i].qs.toString().replace("e-", "")
              ).toFixed(2),
            };
            SendDataToOpportunity.push(ObjSendDataToOpportunity);
            //}
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading8(false);
        });
    } catch (error) {}
  };

  const GetSupplyTopFillingAppsFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading9(true);
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/getFillAppsData?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data9 = res.data;
          setData9(data9);
          SendDataToTopFillingApps = [];
          ObjSendDataToTopFillingApps = {};
          for (let i = 0; i < data9.responseData.data.length; i++) {
            ObjSendDataToTopFillingApps = {
              AppName: data9.responseData.data[i].app_name.name,
              AppBundle: data9.responseData.data[i].app_bundle.name,
              OS: data9.responseData.data[i].os.name,
              Fill: data9.responseData.data[i].fill,
              Revenue: data9.responseData.data[i].revenue_total,
            };
            SendDataToTopFillingApps.push(ObjSendDataToTopFillingApps);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading9(false);
        });
    } catch (error) {}
  };

  const GetSupplyAppQualityDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    // if (
    //   dateFrom === `&startDate=${CurrnetDate}` &&
    //   dateTo === `&endDate=${CurrnetDate}`
    // ) {

    //   setStart(`&startDate=${formatDate(yesterday)}`);
    //   setEnd(`&endDate=${formatDate(yesterday)}`);
    //   // start = `&startDate=${formatDate(yesterday)}`;
    //   // end = `&endDate=${formatDate(yesterday)}`;
    // } else {
    //   setStart(dateFrom);
    //   setEnd(dateTo);
    // }
    // setIsLoading8(true);
    // // change DateFrom to &startDate=2023-01-08 of any date to work !
    setIsLoading10(true);
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/getAppQualityData?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data10 = res.data;
          setData10(data10);
          SendDataToAppQuality = [];
          ObjSendDataToAppQuality = {};
          for (let i = 0; i < data10.responseData.data.length; i++) {
            ObjSendDataToAppQuality = {
              app_bundle: data10.responseData.data[i].app_bundle.name,
              sivt:
                data10.responseData.data[i].sivt /
                data10.responseData.data[i].scannedImpressions,
              givt:
                data10.responseData.data[i].givt /
                data10.responseData.data[i].scannedImpressions,
              scannedImpressions:
                data10.responseData.data[i].scannedImpressions,
            };

            SendDataToAppQuality.push(ObjSendDataToAppQuality);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading10(false);
        });
    } catch (error) {}
  };
  const GetDailyIncomeFunc1 = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading2(true);
    try {
      let base64 = require("base-64"); // install it before use from npm i base-64
      axios
        .get(
          `${MyUrl}/api/Dashboard/getDailyIncome?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data2 = res.data;
          setData2(data2);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading2(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // GetSupplyAppQualityDataFunc();
    // GetSupplyTopFillingAppsFunc();
    // GetSupplyOpportunityDataFunc();
    // GetSupplyTrafficSourceDonut();
    // GetSupply3DonutDataFunc();
    // GetSupplyReportsCampOptimizationDataFunc();
    // GetSupplyReportsGraphDataFunc();
    // GetSupplyReportsDataFunc();
    // setChooceCompanies([]);
    // PickDatesToGetData(0);
    // GetDailyIncomeFunc();
    // //GetDailyIncomeFunc1();
    // GetMonthlyIncomeFunc();
    // return () => {
    //   source.cancel("Component unmounted");
    // };
  }, []);

  const GetMonthlyIncomeFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading1(true);
    try {
      axios
        .get(
          `${MyUrl}/api/Dashboard/getMonthlyIncome?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data1 = res.data;
          setData1(data1);
          // Assume responseData is the nested list of objects
          //const result = [];
          // for (let i = 0; i < companies[0].dates.length; i++) {
          //   let sum = 0;
          //   for (let j = 0; j < companies.length; j++) {
          //     sum += companies[j].dates[i].value;
          //   }
          //   result.push({ date: companies[0].dates[i].date, value: sum });
          // }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading1(false);
        });
    } catch (error) {}
  };

  //For CheckBox
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  //End for CheckBox

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
    // PickDatesToGetData(event.target.value);
  };
  //End select Days

  const [OpenRange, SetOpenRange] = useState(false);
  var startDate = Today;
  var endDate = Today;
  // async function PickDatesToGetData(event) {
  //   await RefreshFunc();
  //   setDays(event);
  //   if (event === 0) {
  //     PickedDate = 0;
  //     SetOpenRange(false);
  //     startDate = Today;
  //     endDate = Today;
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyAppQualityDataFunc();
  //   } else if (event === 1) {
  //     PickedDate = 1;
  //     SetOpenRange(false);
  //     startDate = Yesterday;
  //     endDate = Yesterday;
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyAppQualityDataFunc();
  //   } else if (event === 2) {
  //     PickedDate = 2;
  //     SetOpenRange(false);
  //     startDate = SevenDays;
  //     endDate = Yesterday;
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyAppQualityDataFunc();
  //   } else if (event === 3) {
  //     PickedDate = 3;
  //     SetOpenRange(false);
  //     startDate = FirstDayInMonth;
  //     endDate = Yesterday;
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyAppQualityDataFunc();
  //   } else if (event === 4) {
  //     PickedDate = 4;
  //     if (value.$D === undefined) {
  //       startDate = Today;
  //     } else {
  //       startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
  //     }
  //     if (value1.$D === undefined) {
  //       endDate = Today;
  //     } else {
  //       endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
  //     }
  //     SetOpenRange(true);
  //     GetDailyIncomeFunc1();
  //     GetMonthlyIncomeFunc();
  //     GetSupplyReportsGraphDataFunc();
  //     GetSupplyReportsCampOptimizationDataFunc();
  //     GetSupplyTrafficSourceDonut();
  //     GetSupply3DonutDataFunc();
  //     GetSupplyOpportunityDataFunc();
  //     GetSupplyTopFillingAppsFunc();
  //     GetSupplyAppQualityDataFunc();
  //   }
  // }

  // const handleClick = () => {
  //   SetOpenRange(!OpenRange);
  // };

  async function PickDatesToGetData(event) {
    setDays(event);
    if (event === 0) {
      SetOpenRange(false);
      startDate = Today;
      endDate = Today;
      await RefreshFunc(startDate, endDate);
      // GetDailyIncomeFunc1(Today, Today);
      // GetMonthlyIncomeFunc(Today, Today);
    } else if (event === 1) {
      SetOpenRange(false);
      startDate = Yesterday;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 2) {
      SetOpenRange(false);
      startDate = SevenDays;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 3) {
      SetOpenRange(false);
      startDate = FirstDayInMonth;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 4) {
      if (value.$D === undefined) {
        startDate = Today;
      } else {
        startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
      }
      if (value1.$D === undefined) {
        endDate = Today;
      } else {
        endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
      }
      SetOpenRange(true);
      await RefreshFunc(startDate, endDate);
    }
  }
  useEffect(() => {
    // This code will run only when myVariable changes
  }, [OpenRange]);

  //For Date Pick

  var [value, setValue] = React.useState(startDate);
  var [value1, setValue1] = React.useState(endDate);
  const handleChange3 = (newValue) => {
    setValue(newValue);
    startDate = `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`;
    console.log(`startDate = ${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`);
  };

  const handleChange4 = (newValue1) => {
    setValue1(newValue1);
    endDate = `${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`;
    console.log(
      `endDate = ${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`
    );
  };
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  return (
    <div style={{ paddingLeft: "2.5%", paddingRight: "1%", paddingTop: 30 }}>
      <h2>Select Products:</h2>
      {isLoading ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            width={750}
            height={80}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                overflowX: width > 766 ? "auto" : "scroll",
              }}
            >
              {Array.isArray(data) ? (
                data &&
                data.map((responseData) => (
                  <div>
                    <div
                      key={responseData.id}
                      style={{
                        display: "flex",
                        background: responseData.color,
                        borderRadius: 100,
                        justifyContent: "center",
                        alignItems: "center",
                        margin: 3,
                        paddingRight: 5,
                        height: 40,
                      }}
                    >
                      <CircleCheckbox
                        checked={chooceCompanies.includes(responseData.id)}
                        onChange={(event) =>
                          handleCheckboxChange(event, responseData.id)
                        }
                      />
                      <label>{responseData.name}</label>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  <h5>There is no companies!</h5>
                </>
              )}
              <button
                style={{
                  border: "none",
                  background: "white",
                  cursor: "pointer",
                  minWidth: 60,
                }}
                onClick={() => {
                  setIsLoading1(true);
                  setIsLoading2(true);
                  setIsLoading3(true);
                  setIsLoading4(true);
                  setIsLoading5(true);
                  setIsLoading6(true);
                  setIsLoading7(true);
                  setIsLoading8(true);
                  setIsLoading9(true);
                  setIsLoading10(true);
                  PickDatesToGetData(PickedDate);
                  setIsClicked(true);
                  setTimeout(() => setIsClicked(false), 1000);
                }}
              >
                <Lottie
                  loop={isClicked ? true : false}
                  autoplay={isClicked ? true : false}
                  animationData={reloadpage}
                  rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice",

                    display: "flex",
                    background: "white",
                    borderRadius: 100,
                    justifyContent: "center",
                    alignItems: "center",
                    margin: 3,
                    paddingRight: 5,
                    height: 40,
                    width: 60,
                    minWidth: 60,
                  }}
                  isPaused={isClicked}
                />
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "1%",
              }}
            >
              <Box sx={{ minWidth: 150 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">days</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={days}
                    label="days"
                    onChange={handleChangeDays}
                  >
                    <MenuItem
                      sx={{ width: 200 }}
                      value={0}
                      onClick={() => {
                        PickedDate = 0;
                        PickDatesToGetData(0);
                      }}
                    >
                      Today
                    </MenuItem>
                    <MenuItem
                      value={1}
                      onClick={() => {
                        PickedDate = 1;
                        PickDatesToGetData(1);
                      }}
                    >
                      Yesterday
                    </MenuItem>
                    <MenuItem
                      value={2}
                      onClick={() => {
                        PickedDate = 2;
                        PickDatesToGetData(2);
                      }}
                    >
                      Last 7 Days
                    </MenuItem>
                    <MenuItem
                      value={3}
                      onClick={() => {
                        PickedDate = 3;
                        PickDatesToGetData(3);
                      }}
                    >
                      This Months
                    </MenuItem>
                    <div style={{ height: 1 }}>
                      <Divider />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="From Date"
                          inputFormat="DD-MM-YYYY"
                          value={value}
                          onChange={handleChange3}
                          renderInput={(params) => <TextField {...params} />}
                        />
                        &nbsp;&nbsp;
                        <DesktopDatePicker
                          label="To Date"
                          inputFormat="DD-MM-YYYY"
                          value={value1}
                          onChange={handleChange4}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>

                    <br></br>

                    <MenuItem
                      value={4}
                      onClick={() => {
                        PickedDate = 4;
                        SetOpenRange(true);
                        // PickDatesToGetData(4);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "black",
                            textTransform: "none",
                            fontSize: "100%",
                            borderRadius: "12px",
                          }}
                          onClick={() => {
                            if (value === "" || value1 === "") {
                              console.log("Wrong");
                            } else {
                              console.log("Call Data");
                              SetOpenRange(false);
                              PickDatesToGetData(4);
                            }
                          }}
                        >
                          {/* Filter */}
                          Custom Range
                        </Button>
                      </div>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
        </>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      ></div>
      {/* {OpenRange ? (
        <div>
          <div className="centerIt">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="From Date"
                inputFormat="DD-MM-YYYY"
                value={value}
                onChange={handleChange3}
                renderInput={(params) => <TextField {...params} />}
              />
              &nbsp;&nbsp;
              <h6>-</h6>
              &nbsp;&nbsp;
              <DesktopDatePicker
                label="To Date"
                inputFormat="DD-MM-YYYY"
                value={value1}
                onChange={handleChange4}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>{" "}
            <h6></h6>
          </div>
          <div className="centerIt">
            <br></br>
            <br></br>
            <Button
              variant="contained"
              style={{
                backgroundColor: "black",
                textTransform: "none",
                fontSize: "100%",
                borderRadius: "12px",
              }}
              onClick={() => {
                if (value === "" || value1 === "") {
                  console.log("Wrong");
                } else {
                  console.log("Call Data");

                  PickDatesToGetData(4);
                }
              }}
            >
              Filter
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )} */}
      {isLoading3 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReportsTop3
            SendDataToTop3={SendDataToTop3}
            startDate={startDate}
            endDate={endDate}
          />
        </>
      )}
      {isLoading4 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReportsFirstGraph
            startDate={startDate}
            endDate={endDate}
            SendDataToGraphData={SendDataToGraphData}
            SendDataToGraphData1={SendDataToGraphData1}
            SendDataToGraphData2={SendDataToGraphData2}
            SendDataToGraphData3={SendDataToGraphData3}
          />
        </>
      )}
      {isLoading9 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReports2Tables
            startDate={startDate}
            endDate={endDate}
            SendDataToTopFillingApps={SendDataToTopFillingApps}
          />
        </>
      )}

      {isLoading10 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReports2Tables2
            startDate={startDate}
            endDate={endDate}
            SendDataToAppQuality={SendDataToAppQuality}
          />
        </>
      )}
      {isLoading6 && isLoading7 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReports3Donuts
            startDate={startDate}
            endDate={endDate}
            SendDataTo3Donut={SendDataTo3Donut}
            SendDataTo3Donut1={SendDataTo3Donut1}
            SendDataTo3Donut2={SendDataTo3Donut2}
            CheckTypeOfUser={CheckTypeOfUser}
          />
        </>
      )}
      {/* {isLoading8 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReportsOpportunityRadar
            startDate={startDate}
            endDate={endDate}
            SendDataToOpportunity={SendDataToOpportunity}
          />
        </>
      )} */}
      {/* {isLoading5 ? (
        <>
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            //  width={750}
            height={500}
            borderRadius={100}
          />
        </>
      ) : (
        <>
          <SupplyReportsSourceOptimizationReportTable
            startDate={startDate}
            endDate={endDate}
            SendDataToCampOptimization={SendDataToCampOptimization}
          />
        </>
      )} */}
    </div>
  );
}
